var _circle, _circle2, _circle3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderOpensvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    stroke: "#808080",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0003 10.9989C11.0003 11.1695 10.935 11.3402 10.805 11.4702L7.47232 14.8042C7.21165 15.0649 6.78965 15.0649 6.52898 14.8042C6.26898 14.5435 6.26898 14.1222 6.52898 13.8615L9.39098 10.9989L6.52898 8.13621C6.26898 7.87555 6.26898 7.45421 6.52898 7.19355C6.78965 6.93288 7.21165 6.93288 7.47232 7.19355L10.805 10.5275C10.935 10.6575 11.0003 10.8282 11.0003 10.9989Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6663 10.9989C15.6663 11.1695 15.601 11.3402 15.471 11.4702L12.1383 14.8042C11.8777 15.0649 11.4557 15.0649 11.195 14.8042C10.935 14.5435 10.935 14.1222 11.195 13.8615L14.057 10.9989L11.195 8.13621C10.935 7.87555 10.935 7.45421 11.195 7.19355C11.4557 6.93288 11.8777 6.93288 12.1383 7.19355L15.471 10.5275C15.601 10.6575 15.6663 10.8282 15.6663 10.9989Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderOpensvg);
export default __webpack_public_path__ + "static/media/sliderOpensvg.34edbbf7a3dcaeaee548f2c452231a3d.svg";
export { ForwardRef as ReactComponent };